import {instance} from "./instance";

// Plans rarely change, so they're loaded once per session (page load) and shared by every visit to Settings
let cachedPlans: any[] | null = null;
let plansRequest: Promise<any[]> | null = null;

export const getCachedPlans = () => cachedPlans;

export const subscriptions_get_all = () => {
    if (!plansRequest) {
        plansRequest = instance.post('/billing/products')
            .then((res) => {
                cachedPlans = res.data;
                return res.data;
            })
            .catch((error) => {
                // Let the next visit try again
                plansRequest = null;
                throw error;
            });
    }
    return plansRequest;
}

// Stripe customer portal: update card, invoices, cancel
export const open_billing_portal = () => {
    return instance.post('/billing/portal');
}

export const process_by_id = (id: string) => {
    return instance.post(`/billing/process/${id}`);
}
